import { Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'support-buttons-control',
    templateUrl: 'support-buttons.control.html',
    styleUrl: './support-buttons.control.scss',
    standalone: false,
})
export class SupportButtonsControl extends ControlBase {
    @Input()
    public sendGoogleTrackEvent: boolean = true;

    public onPatreonClick(): void {
        window.open(this.ioc.core.websiteConstants.patreon.getSupportUrl(this.settings.developerPatreonUserName));
    }

    public onKofiClick(): void {
        window.open(this.ioc.core.websiteConstants.kofi.getSupportUrl(this.settings.developerKofiUserName));
    }
}
